import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';

interface BillData {
  name: string;
  description: string;
  amount: number;
  status: string;
  amount_paid: number;
  balance: number;
  allow_partial_payment: boolean;
  is_paid: boolean;
  is_partially_paid: boolean;
  logo?: string;
  wallet: string;
  number: string;
}

interface PaymentResponse {
  rrn: string;
  amount: number;
  order_id: string;
  narration: string;
  purpose: string;
  currency: string;
}
export interface TransactionResponse {
  status: string;
}


@Injectable({
  providedIn: 'root'
})
export class BillService {
  //https://api-sandbox.scripay.com
  private baseUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getBillDetails(billId: string): Observable<BillData> {
    return this.http.get<BillData>(`${this.baseUrl}bills/bill/${billId}`);
  }
  getTrasactionStatus(rrn: string): Observable<TransactionResponse> {
    return this.http.get<BillData>(`${this.baseUrl}bills/bill/payment/${rrn}`);
  }

  initiatePayment(payload: any): Observable<PaymentResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': '',
    });//gateway/bills/bill/pay
    return this.http.post<PaymentResponse>(`${this.baseUrl}bills/bill/pay`, payload, { headers });
  }
}
